import { ContentDatePicker } from "../../../../../Shared/Entities/Constants/DateConstants";

export enum portfolioDashboardTabEnum {
    Summary = "Summary",
    Investments = "Investments",
    Performance = "Performance",
    Insights = "Insights",
    Transactions = "Transactions",
    Activity = "Activity",
    Documents = "Documents",
    Roles = "Roles",
    ESG = "ESG"
}

export enum portfolioDashboardTabPresentationEnum {
    Summary = "Summary",
    Investments = "Investments",
    Performance = "Performance",
    Insights = "Insights",
    Transactions = "Transactions",
    Documents = "Documents",
    Roles = "Roles",
}

export enum prospectDashboardTabEnum {
    Activity = "Activity",
    Documents = "Documents",
    Roles = "Roles",
}

export enum prospectDashboardTabPresentationEnum {
    Documents = "Documents",
    Roles = "Roles",
}

export enum consolidatedAccountDashboardTabEnum {
    Summary = "Summary",
    Investments = "Investments",
    Performance = "Performance",
    Insights = "Insights",
    Transactions = "Transactions",
    Documents = "Documents",
    ESG = "ESG"
}

export enum dashboardRelatedPageEnum {
    ProductOverview = "ProductOverview",
    ClientReport = "ClientReport",
}

export const defaultAccountMinDate = ContentDatePicker.DefaultMinDate;
